<crm-single-select
  [options]="databases"
  [(selectedItem)]="selectedDatabase"
  (selectedItemChange)="selectedDatabaseChange.emit($event)"
  [label]="labelInput ? 'База' : ''"
  [filter]="false"
  [showClear]="showClear"
  [disabled]="disabled"
  styleClass="styleClass"
  [appendTo]="appendTo"
  [class]="'w-full ' + class"
  filterBy="name">
</crm-single-select>
